module.exports = __webpack_public_path__ + "static/media/vitalPoints_Mobile2.91ee2d9a.png";